import React from "react";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "react-bootstrap";
import { MdOutlineResetTv } from "react-icons/md";

const WebsiteListFilterDrawer = ({
  filterDrawerVisible,
  setFilterDrawerVisible,
  mappingType,
  selectedMappingStatus,
  setSelectedMappingStatus,
  websiteTypeItems,
  selectWebsiteType,
  setSelectWebsiteType,
  searchText,
  setSearchText,
  searchWebsiteId,
  setSearchWebsiteId,
  loading,
  handleResetFilter,
  handleSearch,
}) => {
  return (
    <Sidebar
      visible={filterDrawerVisible}
      position="right"
      onHide={() => setFilterDrawerVisible(false)}
      style={{ width: "28rem", maxWidth: "90vw" }}
      header="Filters"
    >
      <div className="d-flex flex-column justify-content-between h-100 gap-1">
        <div>
          <div className="field">
            <label htmlFor="mappingStatus">Mapping Status</label>
            <Dropdown
              inputId="mappingStatus"
              value={selectedMappingStatus}
              onChange={(e) => setSelectedMappingStatus(e.value)}
              options={mappingType}
              optionLabel="name"
              placeholder="Select mapping type"
              className="w-100 md:h-3rem p-inputtext-sm"
            />
          </div>

          <div className="field">
            <label htmlFor="websiteType">Website Type</label>
            <Dropdown
              inputId="websiteType"
              value={selectWebsiteType}
              onChange={(e) => setSelectWebsiteType(e.value)}
              options={websiteTypeItems}
              optionLabel="name"
              placeholder="Select website type"
              className="w-100 md:h-3rem p-inputtext-sm"
            />
          </div>

          <div className="field">
            <label htmlFor="websiteNameSearch">Search by website name</label>
            <span className="p-input-icon-left w-100">
              <i className="pi pi-search" />
              <InputText
                id="websiteNameSearch"
                type="search"
                value={searchText}
                onInput={(e) => setSearchText(e.target.value)}
                placeholder="Search by website name"
                className="md:h-3rem w-100 p-inputtext-sm"
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
            </span>
          </div>

          <div className="field">
            <label htmlFor="websiteIdSearch">Search by website ID</label>
            <span className="p-input-icon-left w-100">
              <i className="pi pi-search" />
              <InputText
                id="websiteIdSearch"
                type="search"
                value={searchWebsiteId}
                onInput={(e) => setSearchWebsiteId(e.target.value)}
                placeholder="Search by website ID"
                className="md:h-3rem w-100 p-inputtext-sm"
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
            </span>
          </div>
        </div>

        <div className="d-flex gap-2 justify-content-between mt-2 pt-3 border-top prime-react-btn">
          <Button
            variant="outline-secondary"
            disabled={loading}
            onClick={handleResetFilter}
            className="w-100"
          >
            Reset
          </Button>
          <button
            disabled={loading}
            onClick={handleSearch}
            className="w-100 btn submit-btn text-white"
          >
            Search
          </button>
        </div>
      </div>
    </Sidebar>
  );
};

export default WebsiteListFilterDrawer;

